<template>
  <section class="d-flex">
    <div class="survey-snapshot-section border">
      <div class="question" v-for="(question, index) in section.questions" :key="index">
        <div class="question-text">
          {{ question.question_text }}
        </div>
        <ul
          class="answer pl-0"
          style="list-style: none"
          v-for="(answer, answerIndex) in question.answers"
          :key="answerIndex"
        >
          <li>
            <b-icon-record-circle-fill class="accent-color" />
            <span>{{ answer.text }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="d-flex align-items-center ml-1">
      <SectionControls :case-study-id="caseStudyId" :index="index" v-if="editable" />
    </div>
  </section>
</template>
<script>
import SectionMixin from '@app/mixins/case_study_section'
import SectionControls from '@components/case_study_sections/SectionControls.vue'

export default {
  name: 'SurveySnapshotSection',
  components: { SectionControls },
  mixins: [SectionMixin],
  props: {
    caseStudyId: { type: Number, required: true },
    section: { type: Object, required: true },
    accentColor: { type: String, required: true },
    index: { type: Number, required: true },
    editable: { type: Boolean, required: false, default: false },
  },
}
</script>

<style lang="sass" scoped>
.survey-snapshot-section
  width: 100%
  padding: 16px
  border-radius: 16px
  background-color: #fafafb
  ul
    margin-bottom: 8px

.question-text
  font-weight: bolder
  font-size: 20px

.answer
  margin-top: 8px
  font-size: 16px
  color: #6c757d
  li
    span
      padding-left: 2px

.accent-color
  color: v-bind("accentColor")
</style>
